/**
 * Tidy a typed phone number, on blur.
 *
 * ⚠️ ON BLUR, NEVER ON EVERY KEYSTROKE. Reformatting as somebody types moves
 * the caret out from under them — they type a digit, the field rewrites, and
 * the cursor lands somewhere else. Waiting until they leave the field means
 * what they see afterwards is exactly what will be sent, with nothing fighting
 * them on the way in.
 *
 * ⚠️ AND IT ONLY REFORMATS WHAT IT UNDERSTANDS. Exactly ten digits, or eleven
 * with a country code. An international number or a note passes through
 * untouched rather than being truncated into a plausible-looking number that
 * belongs to somebody else.
 *
 * Deliberately mirrors apps/api/src/phone.ts. The server formats again on the
 * way out, so this is a courtesy rather than the guarantee — if the two ever
 * disagree, the server wins and the carrier sees the server's version.
 */
export function formatPhone(raw: string): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';

  const ext = s.match(/(?:ext\.?|extension|x)\s*(\d+)/i)?.[1] ?? '';
  let digits = s.replace(/(?:ext\.?|extension|x)\s*\d+.*$/i, '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return s;

  const core = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  return ext ? `${core} ext. ${ext}` : core;
}
